// extracted by mini-css-extract-plugin
module.exports = {"participantHistoryChatChips":"ParticipantHistoryChatChips_participantHistoryChatChips__u3hET","skeleton":"ParticipantHistoryChatChips_skeleton__NNTXM"};